export default "/images/30aee9b19eedddbf4925e8eb6ed4cd59.avif";